import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {DtoArticle} from "./models/DtoArticle";
import {DtoArticleBaseItems} from "./models/DtoArticleBaseItems";
import {SettingsCashregService} from "./settings-cashreg.service";
import {PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {BarcodeComponent} from "./barcode.component";
import {ArticleSupplierComponent} from "./article-supplier.component";
import {DtoArticleSupplier} from "./models/DtoArticleSupplier";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {ArticleDiscountComponent} from "./article-discount.component";
import {DtoArticleDiscount} from "./models/DtoArticleDiscount";

@Component({
    selector: 'article',
    template: require('./article.component.html'),
    styles: [require('./article.component.css')]
})
@AutoUnsubscribe()

export class ArticleComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridBarcode', {static: false}) gridBarcode: DynamicGridComponent;
    @ViewChild('gridPriceMutation', {static: false}) gridPriceMutation: DynamicGridComponent;
    //@ViewChild('gridStockMutation', {static: false}) gridStockMutation: DynamicGridComponent;
    @ViewChild('gridSupplier', {static: false}) gridSupplier: DynamicGridComponent;
    @ViewChild('gridDiscount', {static: false}) gridDiscount: DynamicGridComponent;
    isCalculatingPrice: boolean;
    form: FormGroup;
    dtoObject: DtoArticle;
    baseItems: DtoArticleBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    barcodeConfig: PageSubheaderBarConfig = {
        title: 'BARCODES',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'GENEREREN',
                isSmall: true,
                clickEventType: 'generate'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    barcodeColumnDefinition: ColumnDefinition[] = [
        {
            key: 'barcode',
            label: 'Barcode',
            type: 'string',
            width: '*'
        }
    ];
    priceMutationColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDate',
            label: 'Ingangsdatum',
            type: 'date',
            width: '150px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'btwDescription',
            label: 'BTW %',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Verkoopprijs incl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        },
        {
            key: 'retailPriceEx',
            label: 'Verkoopprijs excl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        },
        {
            key: 'purchasePrice',
            label: 'Inkoopprijs excl.',
            type: 'number',
            width: '*',
            format: '{0:c}'
        }
    ];
    stockMutationColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDate',
            label: 'Ingangsdatum',
            type: 'date',
            width: '140px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'mutationTypeDesc',
            label: 'Type mutatie',
            type: 'string',
            width: '*'
        },
        {
            key: 'stockInitial',
            label: 'Initiële voorraad',
            type: 'number',
            width: '140px'
        },
        {
            key: 'stockMutation',
            label: 'Mutatie',
            type: 'number',
            width: '110px'
        },
        {
            key: 'stockCurrent',
            label: 'Huidige voorraad',
            type: 'number',
            width: '140px'
        }
    ];
    supplierConfig: PageSubheaderBarConfig = {
        title: 'LEVERANCIERS',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'VOORKEUR',
                isSmall: true,
                clickEventType: 'preference'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    supplierColumnDefinition: ColumnDefinition[] = [
        {
            key: 'supplierName',
            label: 'Leverancier',
            type: 'string',
            width: '*'
        },
        {
            key: 'supplierCustomerNo',
            label: 'Klantnummer',
            type: 'string',
            width: '120px'
        },
        {
            key: 'supplierPhoneNumber',
            label: 'Telefoonnummer',
            type: 'number',
            width: '140px'
        },
        {
            key: 'isPreferred',
            label: 'VK',
            type: 'boolean',
            width: '50px'
        }
    ];
    discountConfig: PageSubheaderBarConfig = {
        title: 'KORTINGEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    discountColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '100px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'discountAmount',
            label: 'Korting',
            type: 'number',
            width: '140px'
        }
    ];
    hasPriceChange: boolean;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService,
                private dialogService: DialogService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            useStock: null,
            salesArticle: null,
            departmentId: [null, [SharedValidators.customRequired]],
            articleSalesgroupId: null,
            articleSubSalesgroupId: null,
            cashregGroupId: null,
            cashregSubGroupId: null,
            btwGroupId: [null, [SharedValidators.customRequired]],
            purchasePrice: null,
            purchasePriceEx: null,
            retailPrice: null,
            retailPriceEx: null,
            customerAdvice: null,
            variablePrice: null,
            stockMin: null,
            stockMax: null,
            stockOrderAmount: null,
            stockCurrent: null,
            employeeAdvice: null,
            remarks: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );
        this.form.get('retailPrice').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == this.form.get('btwGroupId').value);
                this.form.patchValue({ ['retailPriceEx']: this.ss.round(((newVal / (100 + btw.percentage)) * 100), 2) });
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('purchasePrice').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == this.form.get('btwGroupId').value);
                this.form.patchValue({ ['purchasePriceEx']: this.ss.round(((newVal / (100 + btw.percentage)) * 100), 2) });
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('retailPriceEx').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == this.form.get('btwGroupId').value);
                this.form.patchValue({ ['retailPrice']: this.ss.round(((newVal * (100 + btw.percentage)) / 100), 2) });
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('purchasePriceEx').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice && this.form.get('btwGroupId').value) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == this.form.get('btwGroupId').value);
                this.form.patchValue({ ['purchasePrice']: this.ss.round(((newVal * (100 + btw.percentage)) / 100), 2) });
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('btwGroupId').valueChanges.subscribe(newVal => {
            if (this.baseItems && !this.isCalculatingPrice) {
                this.isCalculatingPrice = true;
                let btw = this.baseItems.btwGroups.find(x => x.id == newVal);
                if (btw) {
                    this.form.patchValue({['retailPrice']: this.ss.round(((this.form.value.retailPriceEx * (100 + btw.percentage)) / 100), 2)});
                    this.form.patchValue({['purchasePrice']: this.ss.round(((this.form.value.purchasePriceEx * (100 + btw.percentage)) / 100), 2)});
                }
                this.isCalculatingPrice = false;
            }
        });
        this.form.get('useStock').valueChanges.subscribe(newVal => {
            if (newVal) {
                //if (this.gridStockMutation) {
                //    this.gridStockMutation.showData(this.dtoObject.articleStockMutations);
                //}
            }
        });

        if (this.id > 0) {
            this.ds.getArticleById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.isCalculatingPrice = true;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridBarcode.showData(this.dtoObject.articleBarcodes);
                    this.gridPriceMutation.showData(this.dtoObject.articlePriceMutations);
                    //if (this.gridStockMutation) {
                    //    this.gridStockMutation.showData(this.dtoObject.articleStockMutations);
                    //}
                    this.gridSupplier.showData(this.dtoObject.articleSuppliers);
                    this.gridDiscount.showData(this.dtoObject.articleDiscounts);
                    this.isCalculatingPrice = false;
                });
        }
        else {
            this.ds.getArticleNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        purchasePrice: 0,
                        purchasePriceEx: 0,
                        retailPrice: 0,
                        retailPriceEx: 0,
                        salesArticle: true,
                        variablePrice: true,
                        useStock: false,
                        stockCurrent: 0,
                        stockMax: 0,
                        stockMin: 0,
                        stockOrderAmount: 0,
                        articlePriceMutations: [],
                        //articleStockMutations: [],
                        articleSuppliers: [],
                        articleBarcodes: [],
                        articleDiscounts: []
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getArticleById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.articleSalesgroupId = response.articleSalesgroupId;
                                this.dtoObject.articleSubSalesgroupId = response.articleSubSalesgroupId;
                                this.dtoObject.btwGroupId = response.btwGroupId;
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.purchasePrice = response.purchasePrice;
                                this.dtoObject.retailPriceEx = response.retailPriceEx;
                                this.dtoObject.retailPrice = response.retailPrice;
                                this.dtoObject.purchasePriceEx = response.purchasePriceEx;
                                this.dtoObject.salesArticle = response.salesArticle;
                                this.dtoObject.useStock = response.useStock;
                                this.dtoObject.remarks = response.remarks;
                                this.dtoObject.variablePrice = response.variablePrice;

                                for(let i = 0; i < response.articleSuppliers.length; i++) {
                                    this.dtoObject.articleSuppliers.push({
                                        id: 0,
                                        isPreferred: response.articleSuppliers[i].isPreferred,
                                        supplierId: response.articleSuppliers[i].supplierId,
                                        supplierCustomerNo: response.articleSuppliers[i].supplierCustomerNo,
                                        supplierPhoneNumber: response.articleSuppliers[i].supplierPhoneNumber,
                                        supplierName: response.articleSuppliers[i].supplierName
                                    });
                                }

                                for(let i = 0; i < response.articleBarcodes.length; i++) {
                                    this.dtoObject.articleBarcodes.push({
                                        id: 0,
                                        barcode: response.articleBarcodes[i].barcode
                                    });
                                }

                                for(let i = 0; i < response.articleDiscounts.length; i++) {
                                    this.dtoObject.articleDiscounts.push({
                                        id: response.articleDiscounts[i].id,
                                        description: response.articleDiscounts[i].description,
                                        discountAmount: response.articleDiscounts[i].discountAmount,
                                        index: response.articleDiscounts[i].index
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                                this.gridBarcode.showData(this.dtoObject.articleBarcodes);
                                this.gridSupplier.showData(this.dtoObject.articleSuppliers);
                                this.gridDiscount.showData(this.dtoObject.articleDiscounts);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getArticleBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });
    }

    getSubSalesgroups() {
        if (this.baseItems && this.form.get('articleSalesgroupId').value) {
            return this.baseItems.salesgroups.find(x => x.id == this.form.get('articleSalesgroupId').value).articleSubSalesgroups;
        }
        return null;
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    btnBarcodeBarClicked(event) {
        if (event == 'create') {
            this.showBarcodeWindow();
        } else if (event == 'generate') {
            this.ds.generateArticleBarcode().subscribe(res => {
               if (res) {
                   this.dtoObject.articleBarcodes.push({
                      barcode: res,
                      id: 0
                   });
                   this.gridBarcode.showData(this.dtoObject.articleBarcodes);
               }
            });
        } else if (event == 'delete') {
            if (this.gridBarcode.getSelectedId()) {
                this.dtoObject.articleBarcodes.splice(this.dtoObject.articleBarcodes.findIndex(x => x.barcode == this.gridBarcode.getSelectedId()), 1);
                this.gridBarcode.showData(this.dtoObject.articleBarcodes);
            }
        }
    }

    showBarcodeWindow() {
        const dialogRef = this.dialogService.open({
            content: BarcodeComponent
        });

        const dialogContent: BarcodeComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.barcodeSaved
            .subscribe((res: string) => {
                this.dtoObject.articleBarcodes.push({
                    barcode: res,
                    id: 0
                });
                this.gridBarcode.showData(this.dtoObject.articleBarcodes);
            });
    }

    getRetailBtwAmount() {
        return this.form.get('retailPrice').value - this.form.get('retailPriceEx').value;
    }

    getPurchaseBtwAmount() {
        return this.form.get('purchasePrice').value - this.form.get('purchasePriceEx').value;
    }

    checkForPriceChange() {
        if (this.dtoObject.articlePriceMutations.length > 0) {
            let lastPrice = this.dtoObject.articlePriceMutations[0];
            this.hasPriceChange = ((lastPrice.btwGroupId != this.form.get('btwGroupId').value) || (lastPrice.purchasePrice != this.form.get('purchasePrice').value)
                || (lastPrice.purchasePriceEx != this.form.get('purchasePriceEx').value) || (lastPrice.retailPrice != this.form.get('retailPrice').value)
                || (lastPrice.retailPriceEx != this.form.get('retailPriceEx').value));
        }

        if (this.dtoObject.articlePriceMutations.length == 0 || this.hasPriceChange) {
            this.dtoObject.articlePriceMutations.push({
                id: 0,
                retailPriceEx: this.form.get('retailPriceEx').value,
                retailPrice: this.form.get('retailPrice').value,
                purchasePrice: this.form.get('purchasePrice').value,
                btwGroupId: this.form.get('btwGroupId').value,
                mutationDate: new Date(Date.now()),
                purchasePriceEx: this.form.get('purchasePriceEx').value
            });
        }
    }

    /*checkForStockChange() {
        if (this.dtoObject.articleStockMutations.length == 0 && this.form.value.stockCurrent != 0) {
            this.dtoObject.articleStockMutations.push({
                id: 0,
                mutationDate: new Date(Date.now()),
                stockCurrent: this.form.value.stockCurrent,
                mutationType: 1,
                stockInitial: 0,
                stockMutation: this.form.value.stockCurrent
            });
        } else {
            if (this.dtoObject.articleStockMutations.length > 0) {
                let lastStock = this.dtoObject.articleStockMutations[0];
                if (lastStock.stockCurrent != this.form.value.stockCurrent) {
                    this.dtoObject.articleStockMutations.push({
                        id: 0,
                        mutationDate: new Date(Date.now()),
                        stockCurrent: this.form.value.stockCurrent,
                        mutationType: 1,
                        stockInitial: lastStock.stockCurrent,
                        stockMutation: this.form.value.stockCurrent - lastStock.stockCurrent
                    });
                }
            }
        }
    }*/

    btnSupplierBarClicked(event) {
        if (event == 'create') {
            this.showSupplierWindow();
        } else if (event == 'preference') {
            if (this.gridSupplier.getSelectedId()) {
                for(let i = 0; i < this.dtoObject.articleSuppliers.length; i++) {
                    if (this.dtoObject.articleSuppliers[i].supplierId == this.gridSupplier.getSelectedId()) {
                        this.dtoObject.articleSuppliers[i].isPreferred = true;
                    } else {
                        this.dtoObject.articleSuppliers[i].isPreferred = false;
                    }
                }
                this.gridSupplier.showData(this.dtoObject.articleSuppliers);
            }
        } else if (event == 'delete') {
            if (this.gridSupplier.getSelectedId()) {
                this.dtoObject.articleSuppliers.splice(this.dtoObject.articleSuppliers.findIndex(x => x.supplierId == this.gridSupplier.getSelectedId()), 1);
                if (this.dtoObject.articleSuppliers.length == 1) {
                    this.dtoObject.articleSuppliers[0].isPreferred = true;
                }
                this.gridSupplier.showData(this.dtoObject.articleSuppliers);
            }
        }
    }

    showSupplierWindow() {
        if (this.baseItems) {
            const dialogRef = this.dialogService.open({
                content: ArticleSupplierComponent
            });

            const dialogContent: ArticleSupplierComponent = dialogRef.content.instance;
            dialogContent.dialog = dialogRef;
            dialogContent.allSuppliers = this.baseItems.suppliers;
            dialogContent.chosenSuppliers = this.dtoObject.articleSuppliers;
            dialogContent.supplierSaved
                .subscribe((res: DtoArticleSupplier) => {
                    this.dtoObject.articleSuppliers.push(res);
                    this.gridSupplier.showData(this.dtoObject.articleSuppliers);
                });
        }
    }

    btnDiscountBarClicked(event) {
        if (event == 'create') {
            if (this.dtoObject.articleDiscounts.length == 0)
                this.showDiscountWindow();
            else
                this.ss.message('U kunt slechts 1 korting per artikel toevoegen');
        } else if (event == 'delete') {
            if (this.gridDiscount.getSelectedId()) {
                this.dtoObject.articleDiscounts.splice(this.dtoObject.articleDiscounts.findIndex(x => x.id == this.gridDiscount.getSelectedId()), 1);
                this.gridDiscount.showData(this.dtoObject.articleDiscounts);
            }
        }
    }

    showDiscountWindow() {
        if (this.baseItems) {
            const dialogRef = this.dialogService.open({
                content: ArticleDiscountComponent
            });

            const dialogContent: ArticleDiscountComponent = dialogRef.content.instance;
            dialogContent.dialog = dialogRef;
            dialogContent.allDiscounts = this.baseItems.discounts;
            dialogContent.chosenDiscounts = this.dtoObject.articleDiscounts;
            dialogContent.discountSaved
                .subscribe((res: DtoArticleDiscount) => {
                    this.dtoObject.articleDiscounts.push(res);
                    this.gridDiscount.showData(this.dtoObject.articleDiscounts);
                });
        }
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.checkForPriceChange();
            //this.checkForStockChange();
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            if (this.hasPriceChange && this.dtoObject.id > 0) {
                this.ds.articleHasFuturePriceChange(0).subscribe(res => {
                    if (res) {
                        this.ss.message('U kunt geen prijzen wijzigen omdat u al een prijswijziging in de toekomst klaar heeft staan.<br>' +
                            'Wilt u nu toch prijzen wijzigen? Klik dan op Prijswijzigingen / Correctie Prijswijziging en verwijder de geagendeerde prijswijziging.');
                    } else {
                        this.saveArticle(result);
                    }
                });
            } else {
                this.saveArticle(result);
            }
        }
    }

    saveArticle(result: DtoArticle) {
        this.ds.saveArticle(result)
            .subscribe(response => {
                if (!response.hasError) {
                    this.closeWindow(true);
                }
                else {
                    this.ss.message(response.errorMessage);
                }
            });
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/article.component.ts